/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_TitleInputs */

const vi_order_title = /** @type {(inputs: Order_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng`)
};

/**

* @param {Order_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_title = /** @type {((inputs?: Order_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_title(inputs)
});